import { render, staticRenderFns } from "./StpButton.vue?vue&type=template&id=672c5688&scoped=true&"
import script from "./StpButton.vue?vue&type=script&lang=js&"
export * from "./StpButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c5688",
  null
  
)

export default component.exports